import type { ComponentThemeStyles } from './types';

export const boldTheme: ComponentThemeStyles = {
  typography: {
    headingFont: 'Montserrat, system-ui, sans-serif',
    bodyFont: 'Montserrat, system-ui, sans-serif',
    baseSize: '16px',
  },
  navbar: {
    background: 'bg-black',
    text: 'text-white',
    brandText: 'text-white',
    linkText: 'text-gray-300',
    linkHover: 'hover:text-white',
    border: '',
    shadow: '',
  },
  navigationMenu: {
    background: 'bg-black',
    text: 'text-white',
    brandText: 'text-white',
    linkText: 'text-gray-300',
    linkHover: 'hover:text-white',
    border: '',
    shadow: '',
    dropdownBackground: 'bg-gray-900',
    dropdownText: 'text-gray-200',
    dropdownHover: 'hover:bg-gray-800',
  },
  hero: {
    background: 'bg-gradient-to-br from-red-600 to-orange-600',
    text: 'text-white',
    buttonStyle: 'bg-black text-white hover:bg-gray-900',
    overlay: 'bg-black/20',
    pattern: true,
  },
  splitHero: {
    background: '#ffffff',
    text: '#111827',
    titleColor: '#000000',
    subtitleColor: '#6b7280',
    taglineColor: '#dc2626',
    buttonBg: '#dc2626',
    buttonText: '#ffffff',
    buttonHover: '#b91c1c',
  },
  htmlSplit: {
    background: '#ffffff',
    text: '#111827',
    titleColor: '#000000',
    subtitleColor: '#6b7280',
    taglineColor: '#dc2626',
    buttonBg: '#dc2626',
    buttonText: '#ffffff',
    buttonHover: '#b91c1c',
  },
  simpleHeader: {
    background: '#1f2937',
    titleColor: '#ffffff',
    subtitleColor: '#d1d5db',
  },
  features: {
    background: 'bg-gray-100',
    cardBg: 'bg-white',
    iconColor: 'text-red-600',
    titleColor: 'text-gray-900',
    textColor: 'text-gray-700',
    borderRadius: 'rounded-xl',
  },
  footer: {
    background: 'bg-black',
    text: 'text-white',
    mutedText: 'text-gray-300',
    border: '',
  },
  cta: {
    background: 'bg-gradient-to-r from-orange-600 to-red-600',
    text: 'text-white',
    buttonStyle: 'bg-black text-white hover:bg-gray-900',
  },
  form: {
    background: 'bg-white',
    inputBg: 'bg-gray-50',
    inputBorder: 'border-gray-300',
    inputText: 'text-gray-900',
    labelColor: 'text-gray-900 font-bold',
    buttonStyle: 'bg-red-600 text-white hover:bg-red-700',
  },
  pricing: {
    background: 'bg-white',
    cardBg: 'bg-white',
    highlightedCard: 'bg-gradient-to-br from-red-600 to-orange-600 text-white',
    titleColor: 'text-gray-900',
    subtitleColor: 'text-gray-700',
    descriptionColor: 'text-gray-600',
    planTitle: 'text-gray-900',
    planDescription: 'text-gray-700',
    priceColor: 'text-gray-900',
    periodColor: 'text-gray-700',
    featureColor: 'text-gray-800',
    checkColor: '#dc2626',
    highlightedTitle: 'text-white',
    highlightText: '#dc2626',
    highlightedDescription: 'text-red-100',
    highlightedPrice: 'text-white',
    highlightedPeriod: 'text-red-100',
    highlightedFeature: 'text-white',
    highlightedCheckColor: '#ffffff',
    borderColor: 'border-gray-300',
    highlightBorder: 'border-red-500',
    highlightRing: 'ring-red-600',
    hoverGlow: 'hover:shadow-red-600/25',
    badgeBg: '#dc2626',
    badgeText: 'white',
    buttonBg: '#dc2626',
    highlightedButtonBg: '#000000',
  },
  mediaText: {
    background: '#000000',
    titleColor: '#ffffff',
    textColor: '#d1d5db',
    accentColor: '#dc2626',
  },
  faq: {
    background: '#000000',
    titleColor: '#ffffff',
    subtitleColor: '#d1d5db',
    questionColor: '#ffffff',
    answerColor: '#d1d5db',
    itemBackground: '#1f2937',
    itemBorder: '#374151',
    iconColor: '#dc2626',
  },
  testimonials: {
    background: '#111827',
    titleColor: '#ffffff',
    subtitleColor: '#d1d5db',
    cardBackground: '#1f2937',
    cardBorder: '#374151',
    quoteColor: '#e5e7eb',
    nameColor: '#ffffff',
    roleColor: '#9ca3af',
    starColor: '#dc2626',
  },
  countdownTimer: {
    background: '#1f2937',
    text: '#ffffff',
    headline: '#ffffff',
    subheadline: '#d1d5db',
    number: '#dc2626',
    label: '#9ca3af',
  },
  imageGallery: {
    background: '#1f2937',
    text: '#ffffff',
    title: '#ffffff',
    subtitle: '#d1d5db',
    caption: '#e5e7eb',
    filterButton: '#374151',
    filterButtonActive: '#dc2626',
  },
  imageInfo: {
    background: '#1f2937',
    text: '#ffffff',
    title: '#ffffff',
    subtitle: '#d1d5db',
    imageBorder: '#374151',
    buttonBg: '#dc2626',
    buttonText: '#ffffff',
  },
  imageCard: {
    background: '#1f2937',
    overlayColor: '#000000',
    title: '#ffffff',
    description: '#d1d5db',
    buttonBg: '#dc2626',
    buttonText: '#ffffff',
  },
  team: {
    background: '#1f2937',
    cardBg: '#111827',
    nameColor: '#ffffff',
    roleColor: '#9ca3af',
    borderColor: '#374151',
  },
  video: {
    background: '#111827',
    titleColor: '#ffffff',
    subtitleColor: '#d1d5db',
    textColor: '#e5e7eb',
  },
  textBlocks: {
    background: '#1f2937',
    titleColor: '#ffffff',
    textColor: '#e5e7eb',
    linkColor: '#dc2626',
  },
  titleSubtitle: {
    background: '#111827',
    titleColor: '#ffffff',
    subtitleColor: '#d1d5db',
    buttonBg: '#dc2626',
    buttonText: '#ffffff',
  },
  contactInfo: {
    background: '#1f2937',
    titleColor: '#ffffff',
    textColor: '#e5e7eb',
    accentColor: '#dc2626',
  },
  headContent: {},
  bodyEnd: {},
  htmlEmbed: {
    background: '#1f2937',
  },
  promoBanner: {
    background: '#dc2626',
    text: '#ffffff',
    linkText: '#ffffff',
    dismissButton: '#ffffff',
  },
  logocloud: {
    background: '#111827',
    titleColor: '#ffffff',
    subtitleColor: '#9ca3af',
  },
  stats: {
    background: '#0f172a',
    titleColor: '#ffffff',
    subtitleColor: '#94a3b8',
    valueColor: '#ef4444',
    labelColor: '#f1f5f9',
    descriptionColor: '#94a3b8',
  },
  blogPreview: {
    background: '#1e293b',
    titleColor: '#ffffff',
    subtitleColor: '#94a3b8',
    cardBackground: '#334155',
    cardTitle: '#f1f5f9',
    cardExcerpt: '#cbd5e1',
    linkColor: '#ef4444',
  },
  conversionPopup: {
    overlay: 'rgba(0,0,0,0.65)',
    panelBackground: '#1f2937',
    headlineColor: '#ffffff',
    bodyTextColor: '#e5e7eb',
    buttonBackground: '#ef4444',
    buttonText: '#ffffff',
    closeButton: '#9ca3af',
  },
  blog: {
    pageBackground: '#111827',
    headerBackground: '#000000',
    titleColor: '#ffffff',
    descriptionColor: '#e5e7eb',
    textColor: '#e5e7eb',
    mutedTextColor: '#d1d5db',
    linkColor: '#ef4444',
    linkHoverColor: '#f87171',
    cardBackground: '#1f2937',
    cardBorder: '#374151',
    cardShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
    cardHoverShadow: '0 10px 15px rgba(220, 38, 38, 0.2)',
    postTitleColor: '#ffffff',
    postTextColor: '#f3f4f6',
    postMetaColor: '#d1d5db',
    tagBackground: '#374151',
    tagText: '#f3f4f6',
    tagActiveBackground: '#dc2626',
    tagActiveText: '#ffffff',
    sidebarBackground: '#1f2937',
    sidebarTitleColor: '#ffffff',
    paginationBackground: '#1f2937',
    paginationText: '#e5e7eb',
    paginationBorder: '#374151',
    paginationActiveBackground: '#dc2626',
    paginationActiveText: '#ffffff',
    paginationDisabledOpacity: '0.5',
    iconColor: '#d1d5db',
    loadingSpinnerColor: '#dc2626',
    errorIconColor: '#9ca3af',
    errorButtonBackground: '#dc2626',
    errorButtonText: '#ffffff',
  },
};
